var Language;
(function (Language) {
    const $select = document.querySelector('#change-language');
    if ($select) {
        $select.querySelectorAll('option').forEach(($option) => {
            if (!$option.getAttribute('data-href')) {
                $option.remove();
            }
        });
        $select.addEventListener('change', () => {
            const $selected = $select.querySelector('option:checked');
            const url = $selected.getAttribute('data-href');
            if (url) {
                window.location.href = url;
            }
        });
    }
})(Language || (Language = {}));
